import React, { useEffect, useState, useCallback } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebaseConfig";
import { useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import "./NuestrosProductos.css";

const NuestrosProductos = () => {
    const [productos, setProductos] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loading, setLoading] = useState(true);
    const [productosPorBloque, setProductosPorBloque] = useState(getProductosPorBloque());
    const [intervalo, setIntervalo] = useState(getIntervaloPorPantalla());
    const [startX, setStartX] = useState(null);
    const navigate = useNavigate();

    function getProductosPorBloque() {
        if (window.innerWidth <= 768) return 1;
        if (window.innerWidth <= 1024) return 2;
        return 4;
    }

    function getIntervaloPorPantalla() {
        return window.innerWidth < 576 ? 2500 : 5000;
    }

    useEffect(() => {
        const fetchProductos = async () => {
            setLoading(true);
            try {
                const querySnapshot = await getDocs(collection(db, "productos"));
                const productosArray = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                    loaded: false,
                }));
                setProductos(productosArray.sort(() => 0.5 - Math.random()).slice(0, 8));
            } catch (error) {
                console.error("Error al obtener los productos:", error);
            }
            setLoading(false);
        };
        fetchProductos();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setProductosPorBloque(getProductosPorBloque());
            setIntervalo(getIntervaloPorPantalla());
            setCurrentIndex(0);
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("orientationchange", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("orientationchange", handleResize);
        };
    }, []);

    const avanzarCarrusel = useCallback(() => {
        const totalBloques = Math.ceil(productos.length / productosPorBloque);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % totalBloques);
    }, [productos, productosPorBloque]);

    const retrocederCarrusel = useCallback(() => {
        const totalBloques = Math.ceil(productos.length / productosPorBloque);
        setCurrentIndex((prevIndex) => (prevIndex - 1 + totalBloques) % totalBloques);
    }, [productos, productosPorBloque]);

    useEffect(() => {
        const interval = setInterval(() => {
            avanzarCarrusel();
        }, intervalo);
        return () => clearInterval(interval);
    }, [avanzarCarrusel, intervalo]);

    const handleTouchStart = (e) => {
        setStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        if (!startX) return;
        const diffX = startX - e.touches[0].clientX;
        if (diffX > 50) {
            avanzarCarrusel();
            setStartX(null);
        } else if (diffX < -50) {
            retrocederCarrusel();
            setStartX(null);
        }
    };

    const handleImageLoad = (id) => {
        setProductos((prevProductos) =>
            prevProductos.map((producto) =>
                producto.id === id ? { ...producto, loaded: true } : producto
            )
        );
    };

    const productosMostrar = productos.slice(
        currentIndex * productosPorBloque,
        (currentIndex + 1) * productosPorBloque
    );

    if (loading) {
        return (
            <div className="loading-container d-flex justify-content-center align-items-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <div className="nuestros-productos-container">
            <h2 className="nuestrosproductos-title pt-1">Nuestros Productos</h2>
            <div
                className="productos-carousel"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
            >
                <button className="carousel-button left" onClick={retrocederCarrusel} style={{ display: window.innerWidth < 576 ? 'none' : 'block' }}>
                    &lt;
                </button>
                <div className="productos-cards">
                    {productosMostrar.map((producto) => (
                        <div
                            className={`producto-card ${producto.loaded ? "loaded" : "hidden"}`}
                            key={producto.id}
                        >
                            {!producto.loaded && <div className="imagen-placeholder"></div>}
                            <img
                                src={`/images/${producto.pictureUrl}`}
                                alt={producto.name}
                                className="producto-imagen"
                                onLoad={() => handleImageLoad(producto.id)}
                            />
                            {producto.loaded && (
                                <div className="producto-info">
                                    <span className="producto-categoria">{producto.category}</span>
                                    <h3 className="producto-nombre">{producto.name}</h3>
                                    <button
                                        className="producto-boton"
                                        onClick={() => navigate(`/producto/${producto.id}`)}
                                    >
                                        + Info
                                    </button>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <button className="carousel-button right" onClick={avanzarCarrusel} style={{ display: window.innerWidth < 576 ? 'none' : 'block' }}>
                    &gt;
                </button>
            </div>
            <a href="/productos" className="ver-todos mb-4 mb-md-5 mb-xl-5">Ver todos &rarr;</a>
        </div>
    );
};

export default NuestrosProductos;
